import React from "react";
import Modal from "react-bootstrap/Modal";

interface LoaderExportFileModalProps {
  show: boolean;
}

const LoaderExportFileModal: React.FC<LoaderExportFileModalProps> = ({
  show,
}) => {
  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Body
        className="text-center"
        style={{
          backgroundColor: "#82bac2",
          color: "white",
          padding: "2rem",
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Fetching orders, please wait...</p>
      </Modal.Body>
    </Modal>
  );
};

export default LoaderExportFileModal;
